import { z } from "zod";
import { httpUrl } from "./url.js";

export const createSponsorSchema = z.object({
  organization_id: z.string().min(1, "Organization is required"),
  name: z.string().min(1, "Name is required").max(255),
  full_name: z.string().max(500).nullable().optional(),
  website_url: httpUrl(500).nullable().optional(),
  industry: z.string().max(255).nullable().optional(),
  contact_name: z.string().min(1, "Contact name is required").max(255),
  contact_email: z.string().email("Valid email is required"),
  contact_phone: z.string().max(50).nullable().optional(),
});

export const updateSponsorSchema = z.object({
  name: z.string().min(1, "Name is required").max(255),
  full_name: z.string().max(500).nullable().optional(),
  website_url: httpUrl(500).nullable().optional(),
  industry: z.string().max(255).nullable().optional(),
  contact_name: z.string().min(1, "Contact name is required").max(255),
  contact_email: z.string().email("Valid email is required"),
  contact_phone: z.string().max(50).nullable().optional(),
});

export const addSponsorUserSchema = z.object({
  email: z.string().email("Valid email is required"),
  role_type: z.enum(["sponsor_admin", "sponsor_user"]),
  password: z.string().min(8, "Password must be at least 8 characters").optional(),
});

export const updateSponsorUserSchema = z.object({
  role_type: z.enum(["sponsor_admin", "sponsor_user"]).optional(),
  password: z.string().min(8, "Password must be at least 8 characters").optional(),
});

export type CreateSponsorInput = z.infer<typeof createSponsorSchema>;
export type UpdateSponsorInput = z.infer<typeof updateSponsorSchema>;
export type AddSponsorUserInput = z.infer<typeof addSponsorUserSchema>;
export type UpdateSponsorUserInput = z.infer<typeof updateSponsorUserSchema>;
